import state from './moduleLabelState.js'
import mutations from './moduleLabelMutations.js'
import actions from './moduleLabelActions.js'
import getters from './moduleLabelGetters.js'

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
